import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { mask } from 'remask';
//
import { validaCpf } from '../../functions/validaCpf';
import { validaCnpj } from '../../functions/validaCnpj';
//
import apiPlay from '../../services/apiPlay';
//
import Botao from '../Botao';
//
import SslImg from '../../assets/site_seguro_imagem.png';
//
import AmexLogo from '../../assets/logos/amex.svg';
import VisaLogo from '../../assets/logos/visa.svg';
import MastercardLogo from '../../assets/logos/mastercard.svg';
import EloLogo from '../../assets/logos/elo.svg';
import HipercardLogo from '../../assets/logos/hipercard.svg';
import DiscoverLogo from '../../assets/logos/discover.svg';
import DinersLogo from '../../assets/logos/diners.svg';
//
import styles from './TelaCredito.module.css';

function detectBrand(num) {
  if (!num) return null;
  if (num.startsWith('4')) return { name: 'visa', logo: VisaLogo };
  if (num.startsWith('5')) return { name: 'mastercard', logo: MastercardLogo };
  if (num.startsWith('34') || num.startsWith('37')) return { name: 'amex', logo: AmexLogo };
  if (num.startsWith('36') || num.startsWith('38') || num.startsWith('301') || num.startsWith('305'))
    return { name: 'elo', logo: EloLogo };
  if (num.startsWith('60') || num.startsWith('3841')) return { name: 'hipercard', logo: HipercardLogo };
  if (num.startsWith('6011') || num.startsWith('65')) return { name: 'discover', logo: DiscoverLogo };
  return null;
}

export default function TelaCredito({ fatura, payId }) {
  // STATES
  const [loadingPag, setLoadingPag] = useState(false);
  const [numCartao, setNumCartao] = useState('');
  const [nomeCartao, setNomeCartao] = useState('');
  const [mesVencimento, setmesVencimento] = useState('');
  const [anoVencimento, setAnoVencimento] = useState('');
  const [cvv, setCvv] = useState('');
  const [cpfCnpj, setCpfCnpj] = useState('');
  const [flipped, setFlipped] = useState(false);

  const anoAtual = new Date().getFullYear().toString();
  const brand = detectBrand(numCartao);

  // ── API Payment (original PlayMovel) ──
  function realizaPagamento(e) {
    e.preventDefault();
    setLoadingPag(true);

    let dados = {
      payid: payId,
      pagacartao: '1',
      nomeCartao: nomeCartao,
      numero: numCartao,
      expirames: mesVencimento,
      expiraano: '20' + anoVencimento,
      ccv: cvv,
      nome: '',
      email: '',
      cpfCnpj: cpfCnpj,
      postalCode: '',
      endereconumero: '',
      enderecocomplemento: '',
      telefone: '',
      telefonecelular: '',
    };

    apiPlay
      .post('/api/asaasfatura', dados)
      .then((response) => {
        if (response.data.status === 'CONFIRMED') {
          toast.success('Pagamento Efetuado! Em alguns minutos sua linha será recarregada.');
          setLoadingPag(false);
          setTimeout(() => {
            window.location.reload();
          }, 5000);
          return;
        }

        if (response.data.status !== 'CONFIRMED') {
          if (!!response.data.errors.length) {
            toast.error(response.data.errors[0].description);
          } else {
            toast.error('Erro ao efetuar pagamento.');
          }
          setLoadingPag(false);
          return;
        }
      });
  }

  const formattedNum = mask(numCartao, ['9999 9999 9999 9999']);
  const displayNum = formattedNum || '•••• •••• •••• ••••';
  const displayName = nomeCartao || 'NOME DO TITULAR';
  const displayExp = (mesVencimento || '••') + '/' + (anoVencimento || '••');

  // BODY
  return (
    <section className={styles['container']}>
      {/* ── 3D Card ── */}
      <div
        className={`${styles['card-scene']} ${flipped ? styles['card-scene-flipped'] : ''}`}
        onClick={() => setFlipped((p) => !p)}
      >
        {/* Front */}
        <div className={`${styles['card-face']} ${styles['card-front']}`}>
          <div className={styles['card-top-row']}>
            <div className={styles['card-chip']}>
              <svg viewBox="0 0 48 36" fill="none" width="36" height="27">
                <rect x="1" y="1" width="46" height="34" rx="5" stroke="#d4a853" strokeWidth="1.5" fill="#e8c96a" />
                <line x1="1" y1="13" x2="47" y2="13" stroke="#d4a853" strokeWidth="1" />
                <line x1="1" y1="23" x2="47" y2="23" stroke="#d4a853" strokeWidth="1" />
                <line x1="18" y1="1" x2="18" y2="13" stroke="#d4a853" strokeWidth="1" />
                <line x1="30" y1="23" x2="30" y2="35" stroke="#d4a853" strokeWidth="1" />
              </svg>
            </div>
            {brand && (
              <img
                className={styles['card-brand-logo']}
                src={brand.logo}
                alt={brand.name}
              />
            )}
          </div>
          <div className={styles['card-number']}>{displayNum}</div>
          <div className={styles['card-bottom-row']}>
            <div className={styles['card-holder']}>
              <span className={styles['card-label']}>TITULAR</span>
              <span className={styles['card-holder-name']}>{displayName}</span>
            </div>
            <div className={styles['card-expiry']}>
              <span className={styles['card-label']}>VALIDADE</span>
              <span className={styles['card-expiry-value']}>{displayExp}</span>
            </div>
          </div>
        </div>

        {/* Back */}
        <div className={`${styles['card-face']} ${styles['card-back']}`}>
          <div className={styles['card-stripe']} />
          <div className={styles['card-cvv-area']}>
            <span className={styles['card-cvv-label']}>CVV</span>
            <div className={styles['card-cvv-box']}>
              {cvv || '•••'}
            </div>
          </div>
        </div>
      </div>

      <span className={styles['card-hint']}>Clique no cartão para ver o verso</span>

      {/* ── Form ── */}
      <div className={styles['form-container']}>
        <form className={styles['form']} onSubmit={realizaPagamento}>
          <div className={styles['field']}>
            <label className={styles['field-label']}>Número do cartão</label>
            <input
              className={styles['field-input']}
              value={formattedNum}
              onChange={(e) => setNumCartao(mask(e.target.value, ['9999999999999999']))}
              placeholder="0000 0000 0000 0000"
              required
              inputMode="numeric"
              autoComplete="cc-number"
            />
          </div>

          <div className={styles['field']}>
            <label className={styles['field-label']}>Nome do titular (igual no cartão)</label>
            <input
              className={styles['field-input']}
              value={nomeCartao}
              onChange={(e) => setNomeCartao(e.target.value.toUpperCase())}
              placeholder="NOME COMPLETO"
              required
              autoComplete="cc-name"
            />
          </div>

          <div className={styles['field-row']}>
            <div className={styles['field']}>
              <label className={styles['field-label']}>Mês</label>
              <input
                className={styles['field-input']}
                value={mesVencimento}
                onChange={(e) => setmesVencimento(mask(e.target.value, ['99']))}
                placeholder="MM"
                required
                inputMode="numeric"
                autoComplete="cc-exp-month"
              />
            </div>
            <div className={styles['field']}>
              <label className={styles['field-label']}>Ano</label>
              <input
                className={styles['field-input']}
                value={anoVencimento}
                onChange={(e) => setAnoVencimento(mask(e.target.value, ['99']))}
                placeholder="AA"
                required
                inputMode="numeric"
                autoComplete="cc-exp-year"
              />
            </div>
            <div className={styles['field']}>
              <label className={styles['field-label']}>CVV</label>
              <input
                className={styles['field-input']}
                value={cvv}
                onChange={(e) => setCvv(mask(e.target.value, ['9999']))}
                onFocus={() => setFlipped(true)}
                onBlur={() => setFlipped(false)}
                placeholder="•••"
                required
                inputMode="numeric"
                autoComplete="cc-csc"
              />
            </div>
          </div>

          <div className={styles['field']}>
            <label className={styles['field-label']}>CPF ou CNPJ do titular</label>
            <input
              className={styles['field-input']}
              value={mask(cpfCnpj, ['999.999.999-99', '99.999.999/9999-99'])}
              onChange={(e) => setCpfCnpj(mask(e.target.value, ['99999999999', '99999999999999']))}
              placeholder="000.000.000-00"
              required
              inputMode="numeric"
            />
          </div>

          <Botao
            type="submit"
            text="Pagar agora"
            color="primary-g"
            style={{ width: '100%', marginTop: '0.5rem' }}
            loading={loadingPag}
            disabled={
              mesVencimento > '12' ||
              mesVencimento <= '0' ||
              anoVencimento < anoAtual ||
              (cpfCnpj.length > 11 && !validaCnpj(cpfCnpj || '00000000000000')) ||
              (cpfCnpj.length <= 11 && !validaCpf(cpfCnpj || '00000000000'))
            }
          />
        </form>

        <div className={styles['ssl']}>
          <img src={SslImg} alt="site-seguro" className={styles['ssl-img']} />
          <span className={styles['ssl-text']}>&#128274; Site Seguro</span>
        </div>
      </div>
    </section>
  );
}
